import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getCheckoutUrl } from '../utils/utm';

export const FinalCTA = () => {
  const checkoutUrl = getCheckoutUrl();

  return (
    <section 
      data-testid="final-cta"
      className="section-padding px-8 md:px-12 bg-[#0A1628] relative overflow-hidden"
    >
      {/* Background accent shapes */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-amber-600/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-600/5 rounded-full blur-3xl" />
      
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {/* Section label */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="flex items-center justify-center gap-2 mb-8"
          >
          </motion.div>

          <h2 className="font-editorial text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-8">
            37,000 Investors Have Already Made This Decision.{' '}
            <span className="text-amber-500">Your Turn.</span>
          </h2>

          <div className="font-sans text-base md:text-lg text-gray-300 leading-relaxed mb-12 max-w-2xl mx-auto space-y-6 text-left">
            <p>
              Seven dollars. Thirty days. A framework that has been refined over four decades and applied on national television every market day.
            </p>
            <p>
              You do not have to keep investing the way you have been. You do not have to keep wondering if experienced investors see something in the market that no one has ever clearly explained to you. You do not have to keep reacting to every headline without a framework to interpret what it means for your portfolio.
            </p>
            <p>
              The Jump-Start Trial is not asking you to commit to anything. It is asking you to spend $7 and 30 days finding out what a real investing framework feels like.
            </p>
            <p>
              If it does not change how you see the market, cancel. You get your $7 back. You keep the bonus.
            </p>
            <p className="font-medium text-white">
              If it does change how you see the market, you will have made one of the most valuable $7 investments of your life.
            </p>
          </div>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col items-center gap-6"
          >
            <a
              href={checkoutUrl}
              data-testid="final-cta-button"
              className="group inline-flex items-center gap-3 bg-amber-600 hover:bg-amber-500 text-white font-sans font-semibold py-4 px-8 md:py-5 md:px-12 text-xs md:text-sm tracking-wider uppercase whitespace-nowrap transition-all duration-300 hover:shadow-[0_0_40px_rgba(217,119,6,0.4)]"
            >
              Start My 30-Day Trial for $7
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            
            <p className="font-sans text-gray-400 text-xs md:text-sm">
              Cancel anytime. 100% satisfaction guarantee. Full $7 refund if you cancel within the trial period.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
